import {
    epicDocuments,
    epicRefreshToken,
    epicLogin
} from "app/config";


export const FETCH_EPIC_DOC_REQUEST = "FETCH_EPIC_DOC_REQUEST";
export const FETCH_EPIC_DOC_SUCCESS = "FETCH_EPIC_DOC_SUCCESS";
export const FETCH_EPIC_DOC_FAILURE = "FETCH_EPIC_DOC_FAILURE";


export const fetchEpicDocRequest = () => ({
    type: FETCH_EPIC_DOC_REQUEST
});

export const fetchEpicDocSuccess = (data) => ({
    type: FETCH_EPIC_DOC_SUCCESS,
    payload: data
});

export const fetchEpicDocFailure = (error) => ({
    type: FETCH_EPIC_DOC_FAILURE,
    payload: error
});


export const fetchEpicDocuments =
    (patientId, accessToken) => async (dispatch) => {

        try {

            dispatch(fetchEpicDocRequest());

            const endpoint = "DocumentReference";

            const buildUrl = (token) => `${epicDocuments}` + `&patientId=${encodeURIComponent(patientId)}` + `&endpoint=${endpoint}` + `&accessToken=${encodeURIComponent(token)}`;

            let url = buildUrl(accessToken);

            let response;

            try {
                response = await fetch(url, { method: "POST" });
            } catch (err) {
                console.warn("API crashed → trying refresh");
                response = { ok: false };
            }


            if (!response.ok) {

                console.warn("API failed → refreshing token");

                const refreshToken = localStorage.getItem("epicRefreshToken");

                if (!refreshToken) {
                    throw new Error("No refresh token found");
                }

                const refreshRes = await fetch(
                    `${epicRefreshToken}&refreshToken=${encodeURIComponent(refreshToken)}`,
                    {
                        method: "POST"
                    }
                );

                if (!refreshRes.ok) {

                    console.error("Refresh failed → redirect to login");

                    localStorage.removeItem("epicAccessToken");
                    localStorage.removeItem("epicRefreshToken");
                    localStorage.removeItem("epicPatientId");

                    dispatch(fetchEpicDocFailure("Session expired"));

                    window.location.href = epicLogin;
                    return;
                }

                const refreshJson = await refreshRes.json();

                const refreshData = refreshJson?.data;

                const newAccessToken = refreshData?.access_token;
                const newRefreshToken = refreshData?.refresh_token;

                if (!newAccessToken) {
                    throw new Error("Invalid refresh response");
                }

                localStorage.setItem("epicAccessToken", newAccessToken);

                if (newRefreshToken) {
                    localStorage.setItem("epicRefreshToken", newRefreshToken);
                }


                console.log("Retrying API with new token");

                url = buildUrl(newAccessToken);

                const retryResponse = await fetch(url, { method: "POST" });

                if (!retryResponse.ok) {

                    console.error("Retry failed → redirect to login");

                    localStorage.removeItem("epicAccessToken");
                    localStorage.removeItem("epicRefreshToken");
                    localStorage.removeItem("epicPatientId");

                    dispatch(fetchEpicDocFailure("Session expired"));

                    window.location.href = epicLogin;
                    return;
                }

                const retryData = await retryResponse.json();

                dispatch(fetchEpicDocSuccess(retryData?.data?.xmlSections || {}));

                return;
            }


            const data = await response.json();

            dispatch(fetchEpicDocSuccess(data?.data?.xmlSections || {}));

        } catch (error) {

            console.error("Epic document error:", error);

            dispatch(fetchEpicDocFailure(error.message));
        }
    };


const initialState = {
    loading: false,
    xmlSections: {},
    error: null
};

export default function epicDocumentsReducer(state = initialState, action) {

    switch (action.type) {

        case FETCH_EPIC_DOC_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_EPIC_DOC_SUCCESS:
            return {
                ...state,
                loading: false,
                xmlSections: action.payload
            };

        case FETCH_EPIC_DOC_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
}
